import React from "react";



export function LeftSubscription(){
    return(
            <div style = {{"marginTop" : "200px"}}>
                  <img  src = "https://static.uacdn.net/web-cms/daily_live_classes_be8fa5af21.svg?q=75&w=1000&fm=webp" alt = ""/>
            </div>
    )
}